import { render, staticRenderFns } from "./PersonasTabFichajesDetalle.vue?vue&type=template&id=2c6634ac"
import script from "./PersonasTabFichajesDetalle.vue?vue&type=script&lang=js"
export * from "./PersonasTabFichajesDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports